export default class DistributionListModel {
  id: string;
  name: string;
  user_id?: string;
  users: {
    id: string;
  }[];
  individualUserIds = [];
  faxRecipients = [];
  reviews = [];
  canBeDeleted: boolean;
  distributionListIds = [];
  reviewStatus = [];
  newAddedUsers = [];
  newIndividualAddedUsers = [];
  removedUsers = [];
  newDLAdded = [];
  newDLAddedReason: string;

  constructor(data: any) {
    this.id = data.id || undefined;
    this.name = data.name || undefined;
    this.user_id = data?.user_id || undefined;
    this.users = data.users || [];
    this.reviews = data.reviews || [];
    this.canBeDeleted = data.canBeDeleted || false;
    this.newDLAddedReason = '';
  }
}
